/** Join truthy class-name parts with a space. Tiny, dependency-free `clsx`. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter((part): part is string => Boolean(part)).join(' ');
}
